import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FormTrackerService {
  private logoutSubject = new Subject<void>();
  logout$ = this.logoutSubject.asObservable();

  private dirtySubject = new BehaviorSubject<boolean>(false);
  dirty$ = this.dirtySubject.asObservable();

  private disableGuardSubject = new Subject<boolean>();
  disableGuard$ = this.disableGuardSubject.asObservable();

  triggerLogout() {
    this.logoutSubject.next();
  }

  setDirty(value: boolean) {
    this.dirtySubject.next(value);
  }

  isDirty(): boolean {
    return this.dirtySubject.value;
  }

  disableBeforeUnloadGuard() {
    this.disableGuardSubject.next(true);
  }
}